export default __webpack_public_path__ + "static/media/client_final_whatsbot.ea25bf5a.png";